// VerPdfModal.tsx

import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export interface VerPdfModalProps {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  error?: string;
  pdfUrl?: string | null;
  pdfName?: string;
  noTramite: string;
}

export const VerPdfModal = ({
  open,
  onClose,
  loading,
  error,
  pdfUrl,
  pdfName,
  noTramite,
}: VerPdfModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { height: '85vh' } }}
    >
      <DialogTitle sx={{ pr: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography variant="h6" noWrap>
          PDF firmado — {noTramite}
        </Typography>
        <IconButton aria-label="Cerrar" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        {loading && (
          <Alert severity="info" sx={{ m: 2 }}>
            Cargando el PDF firmado...
          </Alert>
        )}

        {!loading && error && (
          <Alert severity="error" sx={{ m: 2 }}>
            {error}
          </Alert>
        )}

        {!loading && !error && pdfUrl && (
          <iframe
            title={`PDF firmado ${noTramite}`}
            src={pdfUrl}
            style={{
              width: '100%',
              flex: 1,
              border: 'none',
              minHeight: '60vh',
            }}
          />
        )}

        {!loading && !error && !pdfUrl && (
          <Alert severity="info" sx={{ m: 2 }}>
            No hay PDF disponible para este trámite.
          </Alert>
        )}
      </DialogContent>
      {pdfUrl && !error && (
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            endIcon={<OpenInNewIcon />}
            component="a"
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Abrir PDF
          </Button>
          <Button onClick={onClose}>Cerrar</Button>
        </DialogActions>
      )}
      {!pdfUrl && (
        <DialogActions>
          <Button onClick={onClose}>Cerrar</Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default VerPdfModal;
